export const USE_SINGLE_S3_FILE_QUERY_KEY = "useSingleS3FileQuery";
export const USE_S3_FILE_COLLECTION_QUERY_KEY = "useS3FileCollectionQuery";
export const USE_DOWNLOAD_S3_FILE_QUERY_KEY = "getAttachment";
